import { Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UIModule, UIRangeComponent } from '@bannerflow/ui';
import { ExpandablePromptInputType } from '@studio/domain/components/ai-studio.types';
import { GenAIService } from '../../state/gen-ai.service';
import { ExpandablePromptComponent } from '../expandable-prompt/expandable-prompt.component';

@Component({
    imports: [UIModule, UIRangeComponent, ExpandablePromptComponent],
    selector: 'structure-options',
    templateUrl: './structure-options.component.html',
    styleUrls: ['./structure-options.component.scss']
})
export class StructureOptionsComponent {
    private genAiService = inject(GenAIService);

    prompt = signal('');
    negativePrompt = signal('');
    showNegativePrompt = false;
    isRequestingStructure = toSignal(this.genAiService.isRequestingStructure$, { initialValue: false });
    actionsDisabled = computed(() => !this.prompt() || this.isRequestingStructure());

    controlStrength = 7;

    ExpandablePromptInputType = ExpandablePromptInputType;

    onPromptChange(newValue: string): void {
        this.prompt.set(newValue);
    }

    onNegativePromptChange(newValue: string): void {
        this.negativePrompt.set(newValue);
    }

    adjustControlStrength(newValue: number): void {
        this.controlStrength = newValue;
    }

    structure(): void {
        this.genAiService.structure(this.prompt(), this.negativePrompt(), this.controlStrength);
    }
}
